import { graphql } from '@client/graphql/types';

export const NailAppointmentConfigurationFragment = graphql(`
  fragment NailAppointmentConfigurationItem on AppointmentBranchConfiguration {
    branchId
    menuId
    enable
    hourBlocking
    autoConfirm

    appointmentLeadMinutes
    appointmentTraitMinutes
    capacityEnabled

    appointmentPause

    reminderTime
    menu {
      title
      menuProducts {
        id
        title
        configurations {
          id
          values {
            name
            price
            id
          }
        }
      }
    }
  }
`);
